import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['option']

  download() {
    const value = this.getOptionValue()

    switch (value) {
      case 'separate-files':
        this.triggerDownloadSeparateFiles()
        break
      case 'one-file':
        this.triggerDownloadOneFile()
        break
      default:
        break
    }
  }

  getOptionValue() {
    let optionValue = ''

    this.optionTargets.forEach(option => {
      if (option.checked) {
        optionValue = option.value
      }
    })

    return optionValue
  }

  triggerDownloadSeparateFiles() {
    const event = new CustomEvent('reports-download-separate-files')
    window.dispatchEvent(event)
  }

  triggerDownloadOneFile() {
    const event = new CustomEvent('reports-download-one-file')
    window.dispatchEvent(event)
  }
}
